import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { redeemRequest as redeemRequestApi } from "services/apis/auth";

export const sendRedeemRequest = createAsyncThunk("redeem/sendRequest", async ({ token, data }: any, thunkAPI) => {
  try {
    const formData = new FormData();
    for (const key in data) {
      formData.append(key, data[key]);
    }
    const response = await redeemRequestApi(token, formData);
    return response.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

interface RedeemedRequestState {
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: RedeemedRequestState = {
  status: "idle",
  error: null,
};

const redeemedRequestSlice = createSlice({
  name: "redeemedRequest",
  initialState,
  reducers: {
    resetRedeemedRequestStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendRedeemRequest.pending, (state) => {
        state.status = "loading";
      })
      .addCase(sendRedeemRequest.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(sendRedeemRequest.rejected, (state, action: any) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetRedeemedRequestStatus } = redeemedRequestSlice.actions;
export default redeemedRequestSlice.reducer;
